export default __webpack_public_path__ + "static/media/Assessment Centres@3x.8b749e97.png";